<div *ngIf="!isUnlockEmailSent">
  <h1 class="harp-card-title">Account Locked</h1>
  <p>
    Your account has been locked. Please unlock your account using your email
    address or try logging in again in an hour.
  </p>

  <form [formGroup]="unlockAccountForm" (ngSubmit)="unlockUser()">
    <harp-input [inputConfig]="emailInputConfig"></harp-input>

    <button
      class="btn btn-primary harp-button-margin"
      type="submit"
      [disabled]="unlockAccountForm.invalid"
    >
      Unlock Account
    </button>
  </form>

  <p>
    If you forgot your password, you may reset your password once your account
    is unlocked.
  </p>
  <p>
    If you are still having trouble accessing your account, please
    <a [routerLink]="['/login/contact']" queryParamsHandling="merge"
      >contact your application's help desk.</a
    >
  </p>
  <p>
    <a [routerLink]="['/login']" queryParamsHandling="merge"
      ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
    >
  </p>
</div>

<!-- Email Successfully Sent Message -->
<div *ngIf="isUnlockEmailSent">
  <h1 class="harp-card-title">Success!</h1>
  <p>
    If we are able to correctly identify your account, you will receive an email
    shortly with instructions unlock your account. If after a sufficient amount
    of time you don’t receive an email, please
    <a [routerLink]="['/login/contact']" queryParamsHandling="merge"
      >contact your application's help desk.</a
    >
  </p>
  <a [routerLink]="['/login']" queryParamsHandling="merge"
    ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
